module.exports = __webpack_public_path__ + "img/Z86_05.260663ed.jpg";